import { Marker } from 'leaflet';

export enum ZoneStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ANY = 'ANY'
}

export enum GeometryTypes {
  POINT = 'Point',
  LINESTRING = 'LineString',
  POLYGON = 'Polygon',
  MULTIPOINT = 'MultiPoint',
  MULTILINESTRING = 'MultiLineString',
  MULTIPOLYGON = 'MultiPolygon'
}

export interface GTCxFeature {
  type: string;
  geometry: {
    type: string;
    coordinates: number[] | number[][] | number[][][] | number[][][][];
  };
  properties?: {
    visible?: boolean;
    name?: string;
    categoryId?: string;
    color?: string;
    categoryName?: string;
    id?: string;
  };
  id?: string;
}

export interface Zone {
  category?: Category;
  id: string;
  name: string;
  categoryId: string;
  status: string;
  geometry: {
    type: string;
    features: GTCxFeature[];
  };
  created?: string;
  modified?: string;
  managedEntity?: {
    managedSourceId?: string | null;
    managedSource?: string | null;
    externallyManaged?: boolean;
  };
}

export interface Category {
  id: string;
  name: string;
  companyId: string;
  divisions: string[];
  color: string;
  type: string;
  visible: boolean;
  status: string;
  created?: string;
  modified?: string;
  managedEntity?: {
    managedSourceId?: string;
    managedSource?: string;
    externallyManaged?: boolean;
  };
}

export enum Resources {
  ZONES = 'zones',
  CATEGORIES = 'categories'
}

export interface GTCxLabel extends Marker {
  zoneArea: number;
  id: string;
  name: string;
  properties: any;
  latLong: number[];
  x?: number;
  y?: number;
  distance?: number;
}

export interface ZoneApiParams {
  accountId: string;
  divisionId?: string;
  categoryId?: string;
  q?: string;
}
